export default class DateUtils {
  static getLocalTimeZone() {
    return new Date().getTimezoneOffset() / 60;
  }
}
